const { SEO_LANDING_PAGES } = require('./landingPages');

const SEO_USE_CASES = [
  {
    title: 'Reunions de feina',
    text: 'Actes, acords i fragments amb timestamps clars.',
  },
  {
    title: 'Entrevistes llargues',
    text: 'Text de base per redactar, revisar i editar amb més rapidesa.',
  },
  {
    title: 'Classes i formació',
    text: "Apunts i contingut consultable a partir de l'àudio original.",
  },
];

const SEO_FAQ_ITEMS = [
  {
    question: "Quina durada d'àudio admet?",
    answer:
      "Està pensat per àudios llargs, com reunions, entrevistes, classes i podcasts. En fitxers molt extensos, el temps de processament pot variar segons la durada i el mode escollit.",
  },
  {
    question: 'Quins formats puc pujar?',
    answer: 'Pots treballar amb formats habituals com MP3, WAV, M4A, FLAC, OGG o OPUS.',
  },
  {
    question: 'Com és la precisió en català?',
    answer:
      "La qualitat depèn de l'àudio. Els millors resultats arriben amb parla clara, volum estable i poc soroll de fons.",
  },
  {
    question: 'Cal registrar-se per provar-ho?',
    answer: 'No. Pots començar a transcriure sense registre obligatori.',
  },
  {
    question: 'Què passa amb la privacitat del meu àudio?',
    answer:
      "El fitxer es fa servir per processar la transcripció. Sense activar «Accepto els termes d'ús i privacitat», no es conserva al corpus. Les aportacions només admeten català gratuït i els àudios PRO no s'utilitzen per entrenar models.",
  },
];

const SEO_PROJECT_NOTE = {
  title: 'Sobre el projecte',
  text:
    "Fes-me l'acta! és un projecte d'Andreu Huguet creat per fer més accessible la transcripció d'àudios en català en contextos quotidians de feina, formació i comunitat.",
};

const DEFAULT_SEO_CONTENT = {
  heading: 'Transcriu àudios llargs en català',
  intro:
    'Converteix reunions, entrevistes i classes en text en minuts. Sense registre obligatori i amb resultats de qualitat.',
  kicker: 'Transcripció automàtica amb IA',
  contentTitle: "Transcripció d'àudios llargs en català",
  contentIntro:
    "Fes-me l'acta! transcriu reunions, entrevistes, classes i podcasts en català a partir de fitxers MP3, WAV, M4A, FLAC, OGG i OPUS. Pots començar sense registre i obtenir text amb marques de temps per revisar l'àudio amb criteri.",
  useCases: SEO_USE_CASES,
  howItWorksTitle: 'Com funciona?',
  howItWorksText:
    "Puja un àudio, tria l'idioma, selecciona el mode ràpid o qualitat i espera que aparegui la transcripció amb timestamps.",
  resultTitle: 'Resultat i precisió',
  resultText:
    'Pots copiar el text transcrit o exportar subtítols en format SRT. La precisió millora amb veus clares, volum estable i poc soroll de fons.',
  privacyTitle: 'Privacitat dels àudios',
  privacyText:
    "Els fitxers es processen temporalment per generar la transcripció. Només es conserven al corpus català si actives l'acceptació voluntària; els àudios PRO no s'utilitzen per entrenar. Revisa la política de privacitat abans de pujar contingut.",
};

function resolveSeoContent(landingPage) {
  return Object.assign({}, DEFAULT_SEO_CONTENT, landingPage, {
    useCases: landingPage?.useCases || DEFAULT_SEO_CONTENT.useCases,
  });
}

function getRelatedLandingPages(landingPage, landingPages = SEO_LANDING_PAGES) {
  return landingPages.filter((page) => page.path !== landingPage?.path);
}

module.exports = {
  DEFAULT_SEO_CONTENT,
  SEO_FAQ_ITEMS,
  SEO_PROJECT_NOTE,
  SEO_USE_CASES,
  getRelatedLandingPages,
  resolveSeoContent,
};
